<template>
  <b-dropdown
    id="dropdown-right"
    size="lg"
    right
    text="Right align"
    variant="link"
    toggle-class="text-decoration-none p-0 mr-3 my-2"
    no-caret
  >
    <template #button-content class="p-0">
      <img
        src="@/assets/imgs/user/userDark.svg"
        class="img-fluid img-user p-0"
        alt="Lang icon"
        width="24"
        v-if="shouldShowProjectNav"
      />
      <img
        src="@/assets/imgs/user/userLight.svg"
        class="img-fluid img-user p-0"
        alt="Lang icon"
        width="24"
        v-if="shouldShowDefaultNav"
      />
    </template>
    <b-dropdown-text>
      <div class="workspace-user-info user-profile__profile">
        <div class="workspace-user-info__info">
          <div class="workspace-user-info__name">
            {{ user.name ?? user.displayName }}
          </div>
          <div class="workspace-user-info__email">
            {{ user.email }}
          </div>
        </div>
      </div>
    </b-dropdown-text>
    <template v-if="!isHomePage">
      <b-dropdown-item-button @click="navigateAcademy">{{$t('profile.academy')}}</b-dropdown-item-button>
      <b-dropdown-item-button @click="navigateProject">{{$t('profile.my-projects')}}</b-dropdown-item-button>
    </template>
    <b-dropdown-item-button @click="onLogout">{{$t('profile.logout')}}</b-dropdown-item-button>
  </b-dropdown>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/shared/Card.vue";
import Swal from "sweetalert2";
export default {
  components: {
    Card,
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    shouldShowProjectNav() {
      return this.$route.path.includes('/template') || 
             this.$route.path.includes('/board');
    },
    shouldShowDefaultNav() {
      return !this.shouldShowProjectNav;
    },
    isHomePage() {
      // Lista de rutas donde mostrar solo la opción de cerrar sesión
      const restrictedRoutes = [
        'home',
        '/home',
        'academy',
        '/academy',
        'groups',
        '/groups',
        'projects',
        '/projects'
        // Puedes añadir más rutas aquí según necesites
      ];
      
      // Verifica si el nombre de la ruta actual está en la lista
      if (this.$route.name && restrictedRoutes.includes(this.$route.name)) {
        return true;
      }
      
      // Verifica si la ruta actual incluye alguno de los paths restringidos
      return restrictedRoutes.some(route => 
        !route.startsWith('/') ? false : this.$route.path.includes(route)
      );
    }
  },
  data() {
    return {
      show: false,
      isEditing: false,
      name: "",
      email: "",
    };
  },
  async mounted() {
    await this.fetchUser();
  },
  watch: {
    user: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.name = newValue.name ?? newValue.displayName;
          this.email = newValue.email;
        } else {
          this.name = "";
          this.email = "";
        }
      },
    },
  },
  methods: {
    ...mapActions("auth", ["fetchUser", "logout"]),
    async onLogout() {
      const result = await Swal.fire({
        title: this.$t("logout.title"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("logout.yes"),
        cancelButtonText: this.$t("logout.no"),
      });

      if (result.isConfirmed) {
        try {
          await this.logout();
          this.$router.push(`/${this.$i18n.locale}/principal-page`);
        } catch (error) {
          console.error("Failed to logout:", error);
          Swal.fire(
            "Error",
            "Hubo un problema al cerrar la sesión. Por favor, inténtalo de nuevo.",
            "error"
          );
        }
      }
    },
    navigateProject() {
      const path = `/${this.$i18n.locale}/projects`;
      if (this.$route.path !== path) this.$router.push(path);
    },
    navigateAcademy(){
      const path = `/${this.$i18n.locale}/academy`;
      if (this.$route.path !== path) this.$router.push(path);
    }
  },
};
</script>
<style scoped>
.workspace-user-info {
  display: flex;
  align-items: center;
}
.base-picture.base-picture-size36 {
  width: 36px;
  height: 36px;
}

.workspace-user-info__picture {
  flex-shrink: 0;
}

.user-picture-class {
  border-radius: 125px;
}

.user-profile__profile .workspace-user-info__name {
  font-size: 18px;
  font-weight: bold;
}
.workspace-user-info__email {
  font-stretch: normal;
  letter-spacing: normal;
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
}
</style>